import React from "react";
import { Link } from "react-router-dom";
import useYoutubeEmbed from "../utils/useYoutubeEmbed";

const Read = () => {
  const embedUrl = useYoutubeEmbed("/api/hero-video/", "27AA1JzF-68");
  return (
    <>
      {/* HERO */}
<section className="hero-section">
  <iframe
    className="hero-video"
    src={embedUrl}
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  />   
        <div className="hero-overlay">
          <div className="hero-badge">TESTIMONY</div>
          <h1>Pastor's Call to Ministry</h1>
          <p>Journey of faith, obedience, and divine assignment</p>
          <div className="hero-divider">
            <span className="divider-line"></span>
            <span className="divider-cross">✦</span>
            <span className="divider-line"></span>
          </div>
        </div>
      </section>

      {/* ================= READ CONTENT ================= */}
      <section className="read-content">
        <div className="content-wrapper">

          {/* Chapter 1 */}
          <article className="read-section">
            <div className="section-number">01</div>
            <div className="section-body">
              <h2>Scared to be a pastor</h2>
              <div className="section-rule"></div>
              <p>
                Two times, I got messages to start a church but I declined and rather got a pastor to do it as 
                I sponsored the church progress. Second time, still, I refused and took over other church responsibilities 
                other than pastoring. The fact that I saw Jesus' Pastors suffering and struggling with poverty, 
                a call to pastorship was hell itself. 
              </p>
            </div>
          </article>

          {/* Chapter 2 */}
          <article className="read-section alt">
            <div className="section-number">02</div>
            <div className="section-body">
              <h2>Church establishment</h2>
              <div className="section-rule"></div>
              <p>
                After being involved in time church starting, 
                God spoke again instructing me to start a church. 
                This time round, I accepted to follow God's voice. 
                I asked God for the name of the church and location to establish the church. 
                While in the thanksgiving service for our successful marriage in the church where I got my wife from, 
                God gave me the name of the church, Gospel City Church International. Later on, 
                God directed me to a place where the church was to be established and 
                that was Naguru Police Children Primary School, where a room that had been last used by 
                a pastor three weeks ago, laid free for use. This is where I opened up the church from. 
                The church rapidly grew bigger every other day and God`s power worked in lives of 
                people, healing, delivering and transforming them.
              </p>
            </div>
          </article>

          {/* Chapter 3 */}
          <article className="read-section">
            <div className="section-number">03</div>
            <div className="section-body">
              <h2>Call to full time ministry</h2>
              <div className="section-rule"></div>
              <p>
                In 2006, my wife dreamt when God was calling me from work into full time ministry 
                but she didn`t tell me because she knew that if I quit work, we were going to be poor. 
                God came again and spoke to her to tell me quit work and get to full time ministry. 
                This time round, the message made her peaceless until she shared it with me. 
                Upon getting the message, I resisted within me, saying perhaps since we just got 
                married two years ago, my wife intends to bring me down and control me financially. 
                I trashed the message and continued working. God again sent her to tell me quit work 
                and get into full time ministry. This time round, when she shared, the message came 
                like an arrow into my heart. I composed myself and went for work but my mind was disturbed 
                and the day never went well with me. While in the office, I started thinking about how to 
                handle this matter of quitting work. An idea dropped into my mind, of going to a prayer mountain 
                to confirm if it was really God who was calling me from work to full time ministry.
              </p>
            </div>
          </article>

          {/* Chapter 4 */}
          <article className="read-section alt">
            <div className="section-number">04</div>
            <div className="section-body">
              <h2>At the prayer place &amp; Carried to heaven</h2>
              <div className="section-rule"></div>
              <p>
                While on the mountain, I spent three days and nights, praying and fasting but 
                God did not speak to me. Then I told God, since you have not spoken to me, 
                am going back to work but never speak to me again about quitting work. 
                That morning I gathered and parked all my belongings into the bag, 
                ready to go back home. But before I set off, I got a voice leading me to go 
                and pray one more time in the forest. The voice led me to go past the forest to an 
                isolated thicket which no one had stepped in or used before. I cleared the place 
                and begun praying. While in prayer, the power of God came and carried me to heaven, 
                I found myself before God and He spoke to me for an hour, showing me three things 
                and my assignment on earth. After that, I was brought back and placed a distance away 
                from where I had spread tree leaves praying upon. Realizing God's experience that I had encountered, 
                I chose to stay another night to give thanks to God.
              </p>
            </div>
          </article>

          {/* Chapter 5 */}
          <article className="read-section">
            <div className="section-number">05</div>
            <div className="section-body">
              <h2>Worship with angels</h2>
              <div className="section-rule"></div>
              <p>
                At 11pm, I went to a field amidst the forest and begun praying, 
                giving thanks to God up to 12am. Afterwards, I entered a worship moment 
                and songs of worship begun flowing, I found myself out of my physical body, 
                in God's atmosphere. At about 1am I begun hearing voices worshiping with me. 
                As I continued worshipping, the voices increased. At around 2:00am, I wondered within me, 
                "I came here alone yet I can hear accompanying voices as if am in a spacious hall." 
                I forced my eyes to open since I was deep in the spirit of God. Opening my eyes, 
                I saw those putting on brilliant white clothes, about a hundred of them, than I said to myself, 
                I have found favor before God and He has sent His Angels to worship with me. 
                I closed my eyes with joy and sunk into deep worship. The voices went on gradually reducing until 
                I heard the last one leave. Then God's voice told me to stop there and go to rest, 
                that was at around 3:00am. I went and rested in my tent until morning when I left for Home. 
                I wrote a resignation letter and stopped working.
              </p>
            </div>
          </article>

          {/* Chapter 6 */}
          <article className="read-section alt">
            <div className="section-number">06</div>
            <div className="section-body">
              <h2>God's working and the rise to high leadership roles</h2>
              <div className="section-rule"></div>
              <p>
                While in ministry, the working of God manifested in healing of many sickness and other 
                difficult situations in people's lives. Physically, people`s standard of living  changed, 
                with many attaining material things, promotions at work, Church growing in numbers of people, 
                among other things. I got into leadership roles at various levels i.e. Chairman Naguru Pastor's fellowship, 
                Chairman Red Ministries Uganda, Chairman East Kampala Pastors` and Ministers` Revival fellowship 
                which I founded to call back the Church into repentance because I saw the church going astray and more 
                other responsibilities I held. 
              </p>
            </div>
          </article>

          {/* Chapter 7 */}
          <article className="read-section">
            <div className="section-number">07</div>
            <div className="section-body">
              <h2>Call into prayer &amp; Church demolition</h2>
              <div className="section-rule"></div>
              <p>
                In the Police barracks land, as the church was growing faster, 
                God started sending me messages, first from a pastress that He was calling me back to seek Him. 
                I neither listened nor followed the message. She got another message when God is calling me into prayer. 
                I went into prayer and God showed me my heart and it was really dirty and rusty. I prayed more and 
                I saw God remove my heart and cleaned it. Since I was the Chairman of East Kampala Pastors and Ministers 
                Revival fellowship, I saw myself unworthy to lead these ministers, I called for a meeting and told the 
                ministers about the state of my life because I wanted to put myself right with God.
              </p>
            </div>
          </article>

          {/* Chapter 8 */}
          <article className="read-section alt">
            <div className="section-number">08</div>
            <div className="section-body">
              <h2>Church demolition</h2>
              <div className="section-rule"></div>
              <p>
                We organized a church seminar and invited many people. We had a visiting preacher from Congo. 
                On day two of the seminar, without any prior warning, police officers came and told ministers 
                who were at church to remove all the properties out so that they can demolish the church building. 
                That order came from their commandant and everything happened just like that. Since I was still at home, 
                a minister called, telling me all that was happening, I rushed, Reaching, the church building was already 
                destroyed. I went to the police authorities to find out what exactly was wrong but nobody gave a reasonable 
                cause for breaking down the church. 
                <br /><br />
                That evening, I told all church ministers and members to go home and start praying from their respective 
                houses or ask God for the church where each could be praying from, because I was not ready to start a church 
                without God clearly showing me the place for church establishment. Within me, I always had a mind that a church 
                can't just be started anyhow, anywhere. I went in my house and started praying. One day I went to our prayer 
                fellowship of East Kampala Pastors and Ministers Revival Fellowship which gathered once in a month. On the way 
                back, with one of the members of the fellowship, we kept sharing a number of things. 
              </p>
            </div>
          </article>

          {/* CTA */}
          <div className="cta-wrapper">
            <div className="cta-ornament">✦ ✦ ✦</div>
            <p className="cta-subtext">The story continues…</p>
            <Link to="/cont" className="btn-read-more">
              Read More
            </Link>
          </div>

        </div>
      </section>

      {/* ================= INTERNAL CSS ================= */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=Cinzel:wght@400;600;700&family=EB+Garamond:ital,wght@0,400;0,500;1,400&display=swap');

        :root {
          --navy: #0a1628;
          --navy-mid: #122040;
          --gold: #c9a84c;
          --gold-light: #e8c96a;
          --cream: #f5f0e8;
          --text: #2a2018;
          --text-light: #5a4e3a;
        }

        /* ---- HERO ---- */
                .hero-section {
            position: relative;
            width: 100%;
            height: 100vh; /* full viewport height */
            overflow: hidden;
          }

          .hero-video {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            transform: translate(-50%, -50%);
            object-fit: cover; /* makes video cover the section */
            filter: brightness(0.45) saturate(0.7); /* optional dark/filter effect */
            pointer-events: none; /* so it doesn’t capture clicks */
          }
        .hero-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          color: #fff;
          padding: 20px;
          background: linear-gradient(
            to bottom,
            rgba(10,22,40,0.3) 0%,
            rgba(10,22,40,0.55) 60%,
            rgba(10,22,40,0.85) 100%
          );
        }
        .hero-badge {
          font-family: 'Cinzel', serif;
          font-size: 0.7rem;
          letter-spacing: 0.4em;
          color: var(--gold);
          border: 1px solid var(--gold);
          padding: 6px 20px;
          margin-bottom: 28px;
          text-transform: uppercase;
          animation: fadeUp 1s ease both;
        }
        .hero-overlay h1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.6rem, 6vw, 5.5rem);
          font-weight: 300;
          letter-spacing: 0.04em;
          line-height: 1.1;
          color: #fff;
          margin: 0 0 16px;
          animation: fadeUp 1s 0.2s ease both;
          text-shadow: 0 2px 30px rgba(0,0,0,0.5);
        }
        .hero-overlay p {
          font-family: 'EB Garamond', serif;
          font-style: italic;
          font-size: clamp(1rem, 2vw, 1.3rem);
          color: rgba(255,255,255,0.8);
          margin: 0 0 32px;
          animation: fadeUp 1s 0.4s ease both;
        }
        .hero-divider {
          display: flex;
          align-items: center;
          gap: 14px;
          animation: fadeUp 1s 0.6s ease both;
        }
        .divider-line {
          display: block;
          width: 80px;
          height: 1px;
          background: var(--gold);
          opacity: 0.7;
        }
        .divider-cross {
          color: var(--gold);
          font-size: 0.9rem;
        }

        /* ---- BODY ---- */
        .read-content {
          background: var(--cream);
          background-image:
            radial-gradient(ellipse at 20% 0%, rgba(201,168,76,0.06) 0%, transparent 60%),
            radial-gradient(ellipse at 80% 100%, rgba(10,22,40,0.05) 0%, transparent 60%);
          font-family: 'EB Garamond', serif;
          color: var(--text);
          padding: 80px 0 60px;
        }

        .content-wrapper {
          max-width: 820px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* ---- SECTIONS ---- */
        .read-section {
          display: grid;
          grid-template-columns: 56px 1fr;
          gap: 32px;
          margin-bottom: 64px;
          padding-bottom: 64px;
          border-bottom: 1px solid rgba(201,168,76,0.2);
          animation: fadeUp 0.7s ease both;
        }
        .read-section:last-of-type {
          border-bottom: none;
        }
        .read-section.alt {
          background: linear-gradient(135deg, rgba(10,22,40,0.03) 0%, transparent 100%);
          border-radius: 2px;
          padding: 32px 32px 32px 0;
          margin-left: -8px;
          padding-left: 8px;
        }

        .section-number {
          font-family: 'Cinzel', serif;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 0.15em;
          color: var(--gold);
          padding-top: 8px;
          opacity: 0.8;
          writing-mode: horizontal-tb;
          align-self: start;
          padding-top: 6px;
        }

        .section-body {
          min-width: 0;
        }

        .section-body h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(1.6rem, 3.5vw, 2.3rem);
          font-weight: 600;
          color: var(--navy);
          margin: 0 0 12px;
          line-height: 1.2;
          letter-spacing: 0.01em;
        }

        .section-rule {
          width: 48px;
          height: 2px;
          background: linear-gradient(90deg, var(--gold), transparent);
          margin-bottom: 20px;
        }

        .section-body p {
          font-size: 1.1rem;
          line-height: 1.95;
          color: var(--text);
          margin: 0;
          font-weight: 400;
        }

        /* ---- CTA ---- */
        .cta-wrapper {
          text-align: center;
          padding: 60px 0 20px;
        }
        .cta-ornament {
          font-size: 0.8rem;
          color: var(--gold);
          letter-spacing: 0.5em;
          margin-bottom: 16px;
          opacity: 0.8;
        }
        .cta-subtext {
          font-family: 'Cormorant Garamond', serif;
          font-style: italic;
          font-size: 1.15rem;
          color: var(--text-light);
          margin-bottom: 28px;
        }
        .btn-read-more {
          display: inline-block;
          padding: 14px 48px;
          background: transparent;
          color: var(--navy);
          font-family: 'Cinzel', serif;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.25em;
          text-transform: uppercase;
          text-decoration: none;
          border: 1.5px solid var(--navy);
          position: relative;
          overflow: hidden;
          transition: color 0.35s ease, border-color 0.35s ease;
        }
        .btn-read-more::before {
          content: '';
          position: absolute;
          inset: 0;
          background: var(--navy);
          transform: translateX(-100%);
          transition: transform 0.35s ease;
          z-index: 0;
        }
        .btn-read-more:hover::before {
          transform: translateX(0);
        }
        .btn-read-more:hover {
          color: var(--gold);
          border-color: var(--navy);
        }
        .btn-read-more span,
        .btn-read-more {
          position: relative;
          z-index: 1;
        }

        /* ---- ANIMATIONS ---- */
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ---- RESPONSIVE ---- */
        @media (max-width: 600px) {
          .read-section {
            grid-template-columns: 1fr;
            gap: 8px;
          }
          .section-number {
            font-size: 0.6rem;
            padding-top: 0;
          }
          .read-section.alt {
            padding: 24px 16px;
            margin-left: 0;
          }
          .hero-overlay h1 {
            font-size: 2.2rem;
          }
          .divider-line {
            width: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default Read;
